export default __webpack_public_path__ + "img/04b17df75c6d866662854b8753533868.png";